export const CustomBarWithBenchmark = (props: any) => {
  const { x, y, width, height, fill, payload } = props;

  if (!payload.benchmarkMax) return null;

  // Lifehack: As we cant get access to yAxis scale function to calculate benchmarkY position,
  // we use a simple mathematical equation to calculate its value based on the relationship of values height - payload.current, and benchmarkHeight - payload.benchmarkMax
  const benchmarkHeight = height * (payload.benchmarkMax / payload.value);
  const benchmarkY = y + (height - benchmarkHeight);

  return (
    <>
      <rect x={x} y={y} width={width} height={height} fill={fill} />

      {benchmarkY !== undefined && (
        <>
          <line
            x1={x - width}
            x2={x + width}
            y1={benchmarkY}
            y2={benchmarkY}
            stroke="black"
            strokeWidth={1}
          />
          <circle cx={x} cy={benchmarkY} r={3} fill="black" />
        </>
      )}
    </>
  );
};
